export default "__VITE_ASSET__CSNFjGm4__"